const locations = [
	"Davis",
	"Durham",
	"Firebaugh Telles",
	"Five Points",
	"Shafter",
];

export default locations;
